export const tableHeaderObject= [
    { key: "number", value: "№"},
    { key: "name", value: "Адрес"},
    { key: "legalForm", value: "Юр. лицо"},
    { key: "unitName", value: "Подразделение"},
    { key: "city", value: "Город"},
];


